export default "__VITE_ASSET__Y8jd6GlT__"